export default __webpack_public_path__ + "static/media/logo_MOBILE.f6154aaa.svg";